module.exports = __webpack_public_path__ + "media/images/dot-fixture-14ad1c126b4b67a51aa28077e90b5643.png";